import { createSelector } from 'reselect';
import { every, size } from 'lodash';
import createSelectors from '../common/utils/selectorUtil';
import { LC_PASSAGE_HALF_INDEX_MAPPING } from './lcConstants';
import * as fromPassage from './passageSelectors';
import { LC_PLAYLIST } from "../common/components/demoVideos/demoVideoConstants";

export const selectors = {
    ...createSelectors(fromPassage, 'passage'),
};

export const getSelectedPassageId = state => state.selectedPassageId;

export const getIsLCDataFetched = state => state.isDataFetched;

export const getLCDemoVideosProgress = state => state.demoVideosProgress;

export const getLCActiveDemoVideoId = state => state.activeVideoId;

export const getLCPassageHalf = state => state.passageHalf;

export const getLCSelectedResponses = state => state.selectedResponses;

export const getLCSelectedResponse = (state, questionIndex) => getLCSelectedResponses(state)[questionIndex];

export const getLCPassageHalfIndex = createSelector(
    getLCPassageHalf,
    passageHalf => LC_PASSAGE_HALF_INDEX_MAPPING[passageHalf]
);

export const getLCComprehensionResult = (state, questionIndex) => (
    {
        item_index: questionIndex,
        passage_id: getSelectedPassageId(state),
        passage_half: getLCPassageHalf(state),
        response: getLCSelectedResponse(state, questionIndex)
    }
);

export const areAllLCDemoVideosWatched = state =>
    size(state.demoVideosProgress) === size(LC_PLAYLIST)
    && every(state.demoVideosProgress, { watched: true });
